// extracted by css-extract-rspack-plugin
export default {"details":"D46Hu","primary":"Kk4MT","primary_main":"nH8H8","primaryMain":"nH8H8","leaderboard_override":"_mPb1","leaderboardOverride":"_mPb1","#":"Gy4Kz","tags":"IQ874"};